module.exports = __webpack_public_path__ + "img/icon-phone.954ce767.svg";